"use client";
import { CourseTypePost } from "@/services/types";
import MainLayout from "../Home/MainLayout";
import BannerPostComponent from "./BannerPostComponent";
import EndPostComponent from "./EndPostComponent";
import ContentPostComponent from "../ckeditor/ContentPostComponent";

export interface CourseTypePageProps {
  data: CourseTypePost;
}
const PostComponent = ({ data }: Readonly<CourseTypePageProps>) => {
  return (
    <MainLayout>
      <BannerPostComponent
        urlBanner={data.imageContent}
        data={data.contentLayout}
      />
      <ContentPostComponent data={data.postContent} />
      <EndPostComponent />
    </MainLayout>
  );
};
export default PostComponent;
